import { Organisation } from '~organisations/domain';

import logo from './images/logo.png';

const tgeConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {},
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default tgeConfig;
